module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/3/3-1082932fa9d56eaa9bdfac919754fa5a.jpg";